import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["asChild"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/primitive.tsx
import * as React from "react";
import * as ReactDOM from "react-dom";
import { createSlot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
var NODES = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "select", "span", "svg", "ul"];
var Primitive = NODES.reduce(function (primitive, node) {
  var Slot = createSlot("Primitive.".concat(node));
  var Node = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild,
      primitiveProps = _objectWithoutProperties(props, _excluded);
    var Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */jsx(Comp, _objectSpread(_objectSpread({}, primitiveProps), {}, {
      ref: forwardedRef
    }));
  });
  Node.displayName = "Primitive.".concat(node);
  return _objectSpread(_objectSpread({}, primitive), {}, _defineProperty({}, node, Node));
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(function () {
    return target.dispatchEvent(event);
  });
}
var Root = Primitive;
export { Primitive, Root, dispatchDiscreteCustomEvent };